export type SelectCombo = {
    label:string,
    value:string
}

export type ResponseRequest = {
    status:number,
    errorMessage?:string,
    dataResponse?:any
}

export  type ResponseRequestGeneric<T> = {
    status:number,
    errorMessage?:string,
    dataResponse?:T
}

export type FilesUpload = {
    uploadFile:File|null,
    src:string,
    nameFile:string
}

export type FileInfo = {
    nombreFile: string,
    file: File,
    id: string
}

export type FileInfoUrl = {
    nombreFile: string,
    file: File,
    id: string,
    url: string,
    type?:string
}

export type WrapperResponse<T> = {
    strEstado:"S"|"N",
    strMensaje:string,
    entidad:T|null
}

export type CustomStyleColumn = {
    HeaderName: string,
    StyleHeader: React.CSSProperties
    condition?: boolean
}



export type InformacionBusquedaUsuario = {
    idpersona:number,
    identificacion:string,
    tipoidentificacion:string,
    nombres:string,
    apellidos:string
}


export enum TipoEncargoUnidad {
    ENCARGADO,
    SUBGROGANTE,
    DELEGADO
}


export type IntervalosHoras = {
    inicio: string,
    fin: string
}

export type KeyValuePair<Tclave,Tvalue> = {
  key:Tclave,
  value:Tvalue
}

export type Horario = {
  horaInicio: string;
  horaFin: string;
  recesoInicio: string;
  recesoFin: string;
};

export type GestionInfo = {
  tipoJustificacion: number;
  observacion: string;
  estado: string;
  tipo: string;
  fechaVencimiento: string;
  mensaje: string;
  horaInicio: string;
  horaFin: string;
  fechaRecuperacionStr: string;
  fechaRecuperacion: string;
  fechaEvento: string;
  tipoGestion: string;
  referenciaa: string;

};


export type Jornada = {
  inicio: string;
  fin: string;
  duracion: string;
  estadoIngreso: string;
  estadoSalida: string;
  iniciorecuperar:number;
  finrecuperar:number;
  estado: string;
  tipo: number;
  tipoIngreso: number;
  tipoSalida: number;
  justificacion?: GestionInfo;
  recuperacion?: GestionInfo;
  gestionJ: Gestion;
  gestionR: Gestion;

};
export type Gestion = {
  id: number;
  descripcion: string;
  tipo: string;
  metodo: string;
};
export type Receso = {
  inicio: string;
  fin: string;
  duracion: string;
  codigo: string;
  estado: string;
  tipo: number;
  tiempoRecuperar:number;
  gestionJ: Gestion;
  gestionR: Gestion;
  justificacion?: GestionInfo;
  recuperacion?: GestionInfo;

};
export  type TipoJustificacion = {
  descripcion: string;
  id: number;
  metodo: string;
  tipo: string;
};

export type JornadaLaboral = {
  idJornada:number;
  fecha: string;
  fechaPlazoSolicitud: string;
  jornada: Jornada;
  receso: Receso;
  horario?: Horario;
  tipo: number;
  finSemanaFeriado: boolean;
};

export type FetchJornadaParams = {
  cedula: string;
  start: string;
  end: string;
};
export interface TipoJornadaInfo {
  id: number;
  descripcion: string;
  color: string;
}
export type PropsCalendario = {
    cedula: string;
    month?: number | null;
    year?: number | null;
    canNavigate?:boolean
};
export type EventCalendar = {
    title: string;
    start: Date;
    end: Date;
    allDay: boolean;
    color: string;
    jornada: JornadaLaboral |GestionInfo ; 
    tipoJornada : string 
    tipo :number
};

export type State = {
    events: EventCalendar[];
    date: Date;
    selectedEvent: JornadaLaboral | null| Error; 
    styledDays:  Map<unknown,unknown>;
    showModal: boolean, 
    loading:boolean, 
    error:boolean, 
    isMounted: boolean ,
    errorMessage :string, 
    loadingModalContent: boolean, 
    tipoJornada: string ,
    nonWorkingDays: Date[]  

};

export interface JornadaCardProps {
    jornadaLaboral: JornadaLaboral; 
    tipo:string;
  }

export   interface ModalFormProps {
    isOpen: boolean;
    tipo: string; 
    jornadaLaboral: JornadaLaboral;
    onAccept: () => void;
    onCancel: () => void;
  }


  export type InfoUnidad= {
      idestructuraorganica:number,
      nombre:string,
      siglas:string,
      idpadre:number,
      articulostr:string
  }